import { type Reducer, useMemo, useReducer } from "react";
import { type ActionType } from "typesafe-actions";

export function useTypesafeActions<
  S,
  Actions extends Record<string, (...args: any[]) => any>,
>(
  reducer: Reducer<S, ActionType<Actions>>,
  initialState: S,
  actions: Actions
): [S, Actions] {
  const [state, dispatch] = useReducer(reducer, initialState);
  const boundActions = useMemo(() => {
    function bindActionCreator(
      actionCreator: (...args: any[]) => any,
      dispatcher: typeof dispatch
    ) {
      return function (this: any, ...args: any) {
        return dispatcher(actionCreator.apply(this, args));
      };
    }

    const newActions = Object.keys(actions).reduce(
      (ba, actionName) => {
        ba[actionName] = bindActionCreator(actions[actionName], dispatch);
        return ba;
      },
      {} as Record<string, (...args: any[]) => any>
    );
    return newActions;
  }, [dispatch, actions]);
  return [state, boundActions as Actions];
}
